module.exports = __webpack_public_path__ + "img/about2.4d663abc.jpg";